import React, { useEffect } from 'react';
import { axisMaxLogo } from '../../images/images';
import cautionGifAnimationJson from '../../images/new_ui_imgs/cautionGif.json';
import lottie from 'lottie-web';

const WindowClosed = ({ ivcDowntimeHeading, ivcDowntimeMessage }) => {

    useEffect(() => {
        const instance = lottie.loadAnimation({
            container: document.querySelector("#window-closed-animation"),
            animationData: cautionGifAnimationJson,
            // loop: false
        })
        return () => {
            instance.destroy()
        }
    }, [])

    return (
        <div className='system-dwn-wrapper window-closed'>
            <div className='sytem-dwn-cntnr'>
                <div className='sytem-dwn-logo'>
                    {/* <img src={cautionGif} alt='MAX_LOGO' /> */}
                    <div id='window-closed-animation'></div>
                </div>
                <div className='sytem-dwn-text'>
                    <h3>{ivcDowntimeHeading}</h3>
                    <p>{ivcDowntimeMessage}</p>
                </div>
            </div>
            <div className='wlcm-scrn-logo'>
                <img src={axisMaxLogo} alt='MAX_LOGO' />
            </div>
        </div>
    );
};

export default WindowClosed;